import { createFileRoute, Link } from '@tanstack/react-router';
import { Avatar, Button, Empty, Modal, Table, Tag } from 'antd';
import {
  IconCoins,
  IconDots,
  IconPlus,
  IconTransferOut,
  IconTrash,
  IconUsers,
  IconUsersGroup
} from '@tabler/icons-react';
import dayjs from 'dayjs';
import * as React from 'react';
import RoundMoreButton from '../../../../microcomponents/RoundMoreButton';
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { customersGroupsQueryOptions } from '../../../../utils/queryOptions';
import { COLORS } from '@next-is-free-monorepo/globals';
import { apiV1 } from '../../../../utils/apiClient';
import CustomersGroupSelectTemplates from '../../../../components/customers/CustomersGroupSelectTemplates';
import { useState } from 'react';
import CustomersGroupOptions from '../../../../components/customers/CustomersGroupOptions';
import PageLoader from '../../../../microcomponents/PageLoader';
import { NButton, NTag } from '@next-is-free-monorepo/nif-web-components';
import NAvatar from '../../../../../../libs/nif-web-components/src/microcomponents/NAvatar';
import { UserGroup02FreeIcons } from '@hugeicons/core-free-icons';
import useShopAttrs from '../../../../utils/hooks/useShopAttrs';
import { planFeatures } from '@next-is-free-monorepo/next-is-free-shared-utils';
import PlanGate from '../../../../components/PlanGate';
import { CustomersGroup } from '@next-is-free-monorepo/next-is-free-types';
import Wrapper from '../../../../components/Wrapper';

export const Route = createFileRoute(
  '/_authenticated/customers/_customersLayout/groups'
)({
  component: RouteComponent,
  pendingComponent: props => <PageLoader />
});

const mockGroup: CustomersGroup = {
  id: '',
  name: '',
  type: 'manual',
  created_at: '',
  shop_id: ''
};

const mockData = Array(5).fill(null).map(() => ({ ...mockGroup }));

function RouteComponent() {

  const shopAttrs = useShopAttrs();
  const groups = useSuspenseQuery(customersGroupsQueryOptions());
  const queryClient = useQueryClient();

  const deleteGroup = useMutation({
    mutationFn: async (id: string) => {
      await apiV1.delete(`/shop/customers/groups/${id}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customers-groups'] });
    }
  });

  const rowOptions = (groupId: string) => ([
    {
      key: '1',
      label: 'Elimina',
      danger: true,
      icon: <IconTrash size={16} />,
      onClick: () => {
        deleteGroup.mutate(groupId);
      }
    }
  ]);

  if (!planFeatures(shopAttrs.data.subscription_plan, 'accessCustomers')) {
    return (
      <PlanGate featureKey={'accessCustomers'}>
        {mockData.map((item) => (
          <div key={item.id}
               className={'py-4 border-b flex items-center justify-between'}>
            <Link to={'/customers/groups/$groupId'} params={{ groupId: item.id }} className={'flex gap-2 items-center'}>
              <NAvatar hugeIcon={UserGroup02FreeIcons} />
              <p className={'font-medium'}>{item.name}</p>
              {item.type === 'manual' ?
                <NTag type={'light'} color={'success'}>Manuale</NTag> :
                <NTag type={'light'} color={'info'}>Automatico</NTag>
              }

            </Link>
            <CustomersGroupOptions group={item} />
          </div>
        ))}
      </PlanGate>
    );
  }

  return (
    <div>
      {!groups.data.length &&
       <div className={'mt-10'}>
         <Empty description={'Nessun gruppo'}/>
       </div>
      }
      {groups.data.map((item) => (
        <div key={item.id}
             className={'py-4 border-b flex items-center justify-between'}>
          <Link to={'/customers/groups/$groupId'} params={{ groupId: item.id }} className={'flex gap-2 items-center'}>
            <NAvatar hugeIcon={UserGroup02FreeIcons} />
            <p className={'font-medium'}>{item.name}</p>
            {item.type === 'manual' ?
              <NTag type={'light'} color={'success'}>Manuale</NTag> :
              <NTag type={'light'} color={'info'}>Automatico</NTag>
            }

          </Link>
          <CustomersGroupOptions group={item} />
        </div>
      ))}
    </div>
  );
}
